module.exports = fox._r("images/offer/acp/freeacp/bbw/thumb-2.jpg", __webpack_public_path__ + "_/_/_/root/images/offer/acp/freeacp/bbw/thumb-2.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/offer/acp/freeacp/bbw/thumb-2.jpg
// module id = 741
// module chunks = 4